import React, { useEffect, useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';


const SelectYear = () => {
  const [year, setYear] = useState(Number(localStorage.getItem('year')) || 2025);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleChange = (value: number) => {
    setYear(value);
    localStorage.setItem('year', String(value));
    handleClose();
  };

  useEffect(() => {
    localStorage.setItem('year', String(year));
  }, []);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        sx={{
          width: '100%',
          minWidth: '90px',
          backgroundColor: '#ededed',
          '&:hover': { backgroundColor: '#e1e1e1' },
        }}
        aria-controls="year-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <ListItemIcon sx={{ minWidth: 28 }}>
          <FuseSvgIcon>heroicons-outline:calendar</FuseSvgIcon>
        </ListItemIcon>
        <span>{year}</span>
      </Button>
      <Menu
        id="year-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleChange(2020)}>2020-yil</MenuItem>
        <MenuItem onClick={() => handleChange(2021)}>2021-yil</MenuItem>
        <MenuItem onClick={() => handleChange(2022)}>2022-yil</MenuItem>
        <MenuItem onClick={() => handleChange(2023)}>2023-yil</MenuItem>
        <MenuItem onClick={() => handleChange(2024)}>2024-yil</MenuItem>
        <MenuItem onClick={() => handleChange(2025)}>2025-yil</MenuItem>
      </Menu>
    </Box>
  );
};

export default SelectYear;